import type { OnPageTransitionEndAsync } from "vike/types";
import { useLoadingStore } from '@repo/ui/stores/loading'

export const onPageTransitionEnd: OnPageTransitionEndAsync = async () => {
  console.log("Page transition end");
  const loadingStore = useLoadingStore()
  loadingStore.stop()
  document.querySelector("body")?.classList.remove("page-is-transitioning");
};
